import React from 'react'
import { Link } from 'react-router-dom'
import { Row, Col, Button } from 'react-bootstrap'
import authBadge from '../img/ORCID-Badge-v-00-AUTHENTICATE.svg'
import collectBadge from '../img/ORCID-Badge-v-01-COLLECT.svg'
import displayBadge from '../img/ORCID-Badge-v-02-DISPLAY.svg'
import connectBadge from '../img/ORCID-Badge-v-03-CONNECT.svg'
import { Helmet } from 'react-helmet'

const OrcidBadge = ({ src, alt }) => (
  <a href="https://orcid.org/content/collect-connect">
    <img src={src} alt={alt} style={{ width: '5rem', maxWidth: '20vw' }} />
  </a>
)

const About = () => {
  return (
    <>
      <Helmet>
        <title>About</title>
      </Helmet>
      <Row>
        <Col>
          <h1>About ORCID</h1>
          <blockquote className="blockquote">
            ORCID provides a persistent digital identifier that distinguishes
            you from every other researcher. Through integration in key research
            workflows such as manuscript and grant submission, it supports
            automated linkages between you and your professional activities
            ensuring that your work is recognised.
          </blockquote>
          <p>
            Find out more from JCU&apos;s{' '}
            <a href="https://libguides.jcu.edu.au/identifiers-engagement/orcid">
              ORCID iD LibGuide
            </a>{' '}
            or the official{' '}
            <a href="https://orcid.org/about/what-is-orcid">What is ORCID?</a>{' '}
            page.
          </p>

          <hr className="mb-3" />

          <h2>ORCID iD linking</h2>
          <p>
            The linking process involves signing into JCU first, then signing
            into your ORCID record to link your accounts. We then keep a record
            of when you did this, proving the ORCID iD is yours. We also offer
            the option to automatically share data between JCU and your ORCID
            record.
          </p>
          <p className="mb-3">
            <OrcidBadge src={authBadge} alt="ORCID Authenticate badge" />{' '}
            <OrcidBadge src={collectBadge} alt="ORCID Collect badge" />{' '}
            <OrcidBadge src={displayBadge} alt="ORCID Display badge" />{' '}
            <OrcidBadge src={connectBadge} alt="ORCID Connect badge" />
          </p>

          <h3>Benefits</h3>
          <ul className="mb-3">
            <li>Officially validates your ORCID iD</li>
            <li>Promotion of your research identity online</li>
            <li>
              Highlighting of your linked ORCID record in the media and more
            </li>
            <li>
              Eligible researchers and students get a Research Portfolio page
            </li>
            <li>
              Optional automatic syncing of data to and from your ORCID record
            </li>
          </ul>

          <h3>Privacy &amp; Security</h3>
          <ul className="mb-3">
            <li>Verifies your ORCID iD for use in research at JCU</li>
            <li>
              We never see your password: you use JCU single sign-on and login
              to the ORCID registry directly
            </li>
            <li>You&apos;re in control: review your settings at any time</li>
            <li>
              JCU&apos;s ORCID iD linker has been awarded all{' '}
              <a href="https://orcid.org/content/collect-connect">
                ORCID Collect &amp; Connect
              </a>{' '}
              badges
            </li>
          </ul>

          <hr className="mb-3" />

          <h3 className="mt-2">Got questions?</h3>
          <div className="d-grid d-sm-block mb-3">
            <Button
              variant="primary"
              className="text-wrap px-4"
              as={Link}
              to="/help"
            >
              Get help
            </Button>
          </div>
        </Col>
      </Row>
    </>
  )
}
export default About
